import styled from 'styled-components';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { H1 } from '@finect/tabular-core/Headings';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

/* eslint-disable */
export const Heading = styled.div`
  width: 100%;
  margin-bottom: ${({ extraMargin }) => (extraMargin ? '42px' : '30px')};

  ${maxMediaQueries.miniDesktop`
    width: 100%;
    max-width: ${({ theme }) => theme.columnWidth * 7 + theme.columnGap * 6}px;
    margin: 0 auto ${({ extraMargin }) => (extraMargin ? '42px' : '30px')};
  `};

  ${/* sc-sel */ H1} {
    padding-bottom: 3px;
  }

  ${/* sc-sel */ ParagraphSmall} {
    max-width: 786px;
    padding-top: 12px;
  }
`;
/* eslint-enable */
